import { render, staticRenderFns } from "./PlayerGames.vue?vue&type=template&id=bfd379e8&scoped=true&"
import script from "./PlayerGames.vue?vue&type=script&lang=js&"
export * from "./PlayerGames.vue?vue&type=script&lang=js&"
import style0 from "./PlayerGames.vue?vue&type=style&index=0&id=bfd379e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd379e8",
  null
  
)

export default component.exports